import { Injectable } from "@angular/core";
import { BaseBrandService, RestrictedSiteInfo } from "@apps/patient-core/src/app/services/abstracts/brand.service";
import { PwaService } from "../pwa.service";
import { CacheService } from "@apps/patient-core/src/app/services/cache.service";
import { HttpService } from "@apps/patient-core/src/app/services/http.service";
import { ThemeService } from "@apps/patient-core/src/app/services/theme.service";
import { BrandInfoEntry } from "@apps/patient-core/src/app/data_model/brand-info";
import { Constants } from "@apps/patient-core/constants";
import { BasePatientsService } from "@apps/patient-core/src/app/services/abstracts/patients.service";
import { BaseAuthService } from "@apps/patient-core/src/app/services/abstracts/auth.service";

@Injectable({
  providedIn: "root",
})
export class ConciergeBrandService extends BaseBrandService {
  constructor(
    _themeService: ThemeService,
    _patientService: BasePatientsService,
    _httpService: HttpService,
    _authService: BaseAuthService,
    _cacheService: CacheService,
    private _pwaService: PwaService
  ) {
    super(_themeService, _patientService, _httpService, _authService, _cacheService);
  }

  public set brand(brand: BrandInfoEntry) {
    super.brand = brand;
    this._pwaService.setupPwa();
  }

  public get brand(): BrandInfoEntry {
    return super.brand;
  }

  public get restrictedSite(): RestrictedSiteInfo | null {
    const data = this._cacheService.get(Constants.RESTRICTED_SITE_STORAGE_KEY);
    if (data) return JSON.parse(data);
    return null;
  }

  public set restrictedSite(restrictedSiteInfo: RestrictedSiteInfo | null) {
    this._cacheService.set(Constants.RESTRICTED_SITE_STORAGE_KEY, JSON.stringify(restrictedSiteInfo));
  }
}
